import { isUri as isValidUrl } from 'valid-url'

export default isValidUrl
